import React from 'react';
import { dpsTheme } from '../../../styles/dpsTheme';

interface VulnerabilityCardProps {
  title: string;
  description: string;
  recommendations: string[];
  severity: 'high' | 'medium' | 'low';
}

export const VulnerabilityCard: React.FC<VulnerabilityCardProps> = ({
  title,
  description,
  recommendations,
  severity,
}) => {
  const getSeverityConfig = () => {
    if (severity === 'high') return dpsTheme.colors.priority.high;
    if (severity === 'medium') return dpsTheme.colors.priority.medium;
    return dpsTheme.colors.priority.low;
  };

  const severityConfig = getSeverityConfig();

  const getSeverityLabel = () => {
    if (severity === 'high') return 'Risque élevé';
    if (severity === 'medium') return 'Risque modéré';
    return 'Risque faible';
  };

  return (
    <div
      style={{
        background: dpsTheme.colors.background.dark,
        border: `1px solid ${severityConfig.border}`,
        borderLeft: `4px solid ${severityConfig.text}`,
        borderRadius: dpsTheme.borderRadius.md,
        padding: dpsTheme.spacing.xl,
        marginBottom: dpsTheme.spacing.lg,
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: dpsTheme.spacing.md, marginBottom: dpsTheme.spacing.md }}>
        <div
          style={{
            width: '40px',
            height: '40px',
            background: severityConfig.bg,
            border: `1px solid ${severityConfig.border}`,
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: severityConfig.text,
          }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>
        <div style={{ fontSize: dpsTheme.typography.fontSize.lg, fontWeight: dpsTheme.typography.fontWeight.semibold, color: dpsTheme.colors.text.primary }}>
          {title}
        </div>
        <span
          style={{
            marginLeft: 'auto',
            background: severityConfig.bg,
            border: `1px solid ${severityConfig.border}`,
            color: severityConfig.text,
            padding: '4px 10px',
            borderRadius: '12px',
            fontSize: dpsTheme.typography.fontSize.xs,
            fontWeight: dpsTheme.typography.fontWeight.bold,
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
          }}
        >
          {getSeverityLabel()}
        </span>
      </div>

      <p
        style={{
          fontSize: dpsTheme.typography.fontSize.base,
          color: dpsTheme.colors.text.tertiary,
          lineHeight: dpsTheme.typography.lineHeight.relaxed,
          marginBottom: dpsTheme.spacing.lg,
        }}
      >
        {description}
      </p>

      <div
        style={{
          background: 'rgba(255, 255, 255, 0.03)',
          borderRadius: '8px',
          padding: dpsTheme.spacing.lg,
        }}
      >
        <div
          style={{
            fontSize: dpsTheme.typography.fontSize.sm,
            fontWeight: dpsTheme.typography.fontWeight.semibold,
            color: dpsTheme.colors.text.muted,
            marginBottom: dpsTheme.spacing.md,
          }}
        >
          Recommandations spécifiques :
        </div>
        {recommendations.map((rec, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: '8px',
              padding: '8px 0',
              fontSize: dpsTheme.typography.fontSize.base,
              color: dpsTheme.colors.text.tertiary,
            }}
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              style={{ marginTop: '2px', flexShrink: 0 }}
            >
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
            {rec}
          </div>
        ))}
      </div>
    </div>
  );
};
